import { AxiosError } from 'axios'

import { ApiErrorBase } from 'api/core/ApiErrorBase'
import { ValidationException } from 'api/errors/ValidationException'
import { ApiException } from 'api/errors/ApiException'

async function checkBLobData(error: any): Promise<any> {
  if (
    error.request?.responseType === 'blob' &&
    error.response &&
    error.response.data instanceof Blob &&
    error.response.data.type &&
    error.response.data.type.toLowerCase().indexOf('json') !== -1
  ) {
    const responseObj = await error.response.data.text()
    return JSON.parse(responseObj)
  }
  return error.response?.data
}

export async function extractApiError(axiosError: AxiosError<any>): Promise<ApiErrorBase> {
  return checkBLobData(axiosError).then(data => {
    if (axiosError.response) {
      const { status } = axiosError.response

      if (data.detail) {
        return new ValidationException(data, axiosError.response)
      }
      if (data.errors) {
        return new ApiException(data, axiosError.response)
      }
      return new ApiErrorBase({
        message: axiosError.message,
        statusCode: status,
        details: data,
      })
    }

    if (axiosError.message) {
      return new ApiErrorBase({
        message: axiosError.message,
        statusCode: axiosError.code ? +axiosError.code : undefined,
      })
    }

    return new ApiErrorBase({
      message: 'Unhandled error happened',
    })
  })
}
